import {Big} from 'big.js';
import {MathUtils, parseBig} from '../utils/math-utils';


export class Tools {


    public static getDiscount(appliedPrice: Big, p90: Big) {
        const fixedAppliedPrice= new Big(new Big(appliedPrice).toFixed(3,1));
        if (fixedAppliedPrice.gte(p90)) {
            return new Big(0);
        } else {
            const discount = this.getCorridorLevelBlockRemise(fixedAppliedPrice, p90);
            return parseBig(discount).div(parseBig("100"));
        }
    }

    private static getCorridorLevelBlockRemise(value: Big, p90: Big): string {
        const result = MathUtils.bigIsNullOrZero(p90) ? new Big("0") : (new Big("1").minus(value.div(p90.round(3,1)))).mul(new Big("100"));
        const convertResultToNumber = Math.ceil(Number(result));
        return convertResultToNumber.toString();
    }

}

